var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 7.3L16.7 2.3C16.3 1.9 15.7 1.9 15.3 2.3L2.3 15.3C2.1 15.5 2 15.7 2 16V21C2 21.6 2.4 22 3 22H8C8.3 22 8.5 21.9 8.7 21.7L21.7 8.7C22.1 8.3 22.1 7.7 21.7 7.3ZM7.6 20H4V16.4L12.8 7.6L16.4 11.2L7.6 20ZM17.8 9.8L14.2 6.2L16 4.4L19.6 8L17.8 9.8Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPencil.065f08a3f1dcdaf2e79798088677b31a.svg";